import { toYouTubeEmbed } from "@/lib/catalog";

export function YouTubeEmbed({ url, title = "Video de la unidad" }) {
  const embed = toYouTubeEmbed(url);
  if (!embed) return null;
  return (
    <div className="aspect-video w-full overflow-hidden rounded-sm border border-[#3E5641]/10 bg-black" data-testid="unit-youtube">
      <iframe
        src={embed}
        title={title}
        className="h-full w-full"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  );
}
